module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NR2Psr/tc-custom/9781613120156.jpg?1705260588049",
      "alt": "This image is the cover for the book Understand Rap"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Understand Rap\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Tongue-in-cheek translations of rap lyrics for the clueless!")]), _c('br'), _c('br'), _vm._v("Rap songs are famous for their double entendres, clever turns of phrase, and general ingenuity, but that doesn’t mean things always make sense the first time around. "), _c('br'), _c('br'), _vm._v("Enter "), _c('i', [_vm._v("Understand Rap")]), _vm._v(", a funny pop-cultural reference based on the website of the same name, which dryly and precisely explains the confusing lyrics and terms used in rap songs—in language that even the most unhip person can understand! "), _c('br'), _c('br'), _vm._v("“Where has this book been all our lives?” —"), _c('i', [_vm._v("Geek Alerts")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Buckholz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William Buckholz is a freelance writer living in Seattle.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0